module.exports = require('./helpers/bundle-url').getBundleURL('jn75v') + "logo.c51670a8.svg";